import type { Lesson } from '../schema.js';

export const ENDGAME_LESSONS: Lesson[] = [
  {
    id: 'endgame-activate-king',
    slug: 'endgame-activate-king',
    title: 'Bring out your king',
    audienceLevel: 'beginner',
    concepts: ['endgame', 'piece-power'],
    steps: [
      {
        kind: 'explain',
        title: 'The king becomes a fighter',
        body: 'In the endgame, when few pieces are left, your king joins the fight. A king in the middle of the board is a strong piece.',
        narration: 'In the endgame, your king can fight too.',
      },
      {
        kind: 'demo',
        title: 'Watch the king march',
        body: 'White walks the king toward the center. From d2 the king can help the pawn.',
        fen: '4k3/8/8/8/4P3/8/8/4K3 w - - 0 1',
        highlight: { from: 'e1', to: 'd2' },
      },
      {
        kind: 'quiz',
        title: 'Endgame check',
        body: 'A quick check on the endgame.',
        questions: [
          { prompt: 'When should your king join the fight?', choices: ['In the endgame, with few pieces left', 'In the very first move'], correct: 0 },
          { prompt: 'A king near the center is:', choices: ['More powerful', 'Less powerful'], correct: 0 },
        ],
      },
    ],
  },
  {
    id: 'endgame-pawn-power',
    slug: 'endgame-pawn-power',
    title: 'Pawn power',
    audienceLevel: 'beginner',
    concepts: ['endgame', 'piece-power'],
    steps: [
      {
        kind: 'explain',
        title: 'A pawn on the march',
        body: 'A pawn that reaches the 8th rank becomes a queen — the strongest piece! Push your passed pawn and support it with your king.',
        narration: 'A pawn that promotes becomes a queen.',
      },
      {
        kind: 'demo',
        title: 'Watch the pawn advance',
        body: 'White pushes the pawn to e6. The black king is far away — the pawn is almost free!',
        fen: '7k/8/8/4P3/8/8/8/6K1 w - - 0 1',
        highlight: { from: 'e5', to: 'e6' },
      },
      {
        kind: 'quiz',
        title: 'Pawn check',
        body: 'A quick check on pawns.',
        questions: [
          { prompt: 'What does a pawn become at the 8th rank?', choices: ['A queen', 'A king', 'It disappears'], correct: 0 },
          { prompt: 'A passed pawn is:', choices: ['A pawn with no enemy pawns in front', 'A pawn still at home'], correct: 0 },
        ],
      },
    ],
  },
];
